(function($) {

	$(document).ready(function() {
		// banner init
		$('.owl-carousel.banner-carousel').owlCarousel({
			loop			: true,
			autoplay		: true,
			autoplayTimeout	: 10000,
			autoHeight		: false,
		    nav				: false,
		    items			: 1,
		    dotsContainer 	: '.banner-dots-container',
		    lazyLoadEager	: 1,
		    animateIn		: 'fadeIn',
		    animateOut		: 'fadeOut',
		    mouseDrag		: false,
		    onInitialized	: callback,
		    URLhashListener	: false,
		});

		// Hide dots if fewer than two slides
		function callback(event) {
			var pages = event.item.count;
			if ( pages < 2 ) {
				$('.banner-dots-container').hide();
			}
		}

		// gallery init
		$('.owl-carousel.gallery-carousel').owlCarousel({
			loop			: true,
			autoplay		: false,
			margin			: 0,
		    nav				: false,
		    dotsContainer 	: '.gallery-dots-container',
		    lazyLoadEager	: 1,
		    responsive : {
		        // breakpoint from 0 up
		        0 : {
		            items	: 1,
		        },
		        // breakpoint from 480 up
		        480 : {
		            items	: 2,
		        },
		        // breakpoint from 768 up
		        768 : {
		            items	: 3,
		        }
		    }
		});

		// gallery prev/next buttons
		$('.customNextBtn').click(function() {
		    $('.owl-carousel.gallery-carousel').trigger('prev.owl.carousel');
		});
		$('.customPrevBtn').click(function() {
		    $('.owl-carousel.gallery-carousel').trigger('next.owl.carousel');
		});

		// home banner prev/next buttons
		$('.home-slide-next').click(function() {
		    $('.owl-carousel.banner-carousel').trigger('next.owl.carousel');
		});
		$('.home-slide-prev').click(function() {
		    $('.owl-carousel.banner-carousel').trigger('prev.owl.carousel');
		});

		if ( $('.banner-home').length ) {
			// get current active slide data slide
			var activeSlide = $('.owl-item.active .banner-slide').data('slide');
			setActiveNav( activeSlide );

			var owl = $('.owl-carousel.banner-carousel');
			// Listen to owl events:
			owl.on('translated.owl.carousel', function(event) {
				activeSlide = $('.owl-item.active .banner-slide').data('slide');
				setActiveNav( activeSlide );
			});

			$('.home-banner-nav .nav-item .item-content').on( 'click', function(e) {
				e.preventDefault();
				var slideId 	= $(this).attr('href').slice(1);
				var bannerSlide = $(".banner-slide[data-slide='" + slideId + "']");
				owl.trigger('to.owl.carousel', bannerSlide.parent('.owl-item:not(.cloned)').index('.owl-item:not(.cloned)'));
				setActiveNav( slideId );
			} );

		}
		// add active class to home slider nav
		function setActiveNav(activeSlide) {
			var navItem = $('.home-banner-nav .nav-item a[href="#' + activeSlide + '"]');
			navItem.parent().addClass('active-item').siblings().removeClass('active-item');
		}

	});

})(jQuery);